//import { ToneDetailsDto } from './tonedetailsdto';
import { CountSearchDetailsDto } from './countsearchdetails';
import { ToneDto } from '../tonedto';

export interface SpecificSearchToneDto
{
    getLanguage():string;
    getSearchKey():string;
    getCategoryId():string;
    getToneId():number;
    getPageNo():number;
    getPagePerCount():number;
    getSearchLanguage():string;

    getCountList(): CountSearchDetailsDto;
    getSongList(): ToneDto[];
    getToneList(): ToneDto[];
    getSortBy():string;
    getAlignBy():string;
}

export class SpecificSearchToneDtoImpl implements SpecificSearchToneDto
{
   
    
    private language: string;
    private searchKey: string;
    private categoryId: string;
    private toneId: number;
    private pageNo: number;
    private pagePerCount: number;
    private searchLanguage: string;
    private countList: CountSearchDetailsDto;
    private songList: ToneDto[];
    private toneList: ToneDto[];
    private alignBy :string;
    private orderBy :string;

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string
    {
        return this.language;
    }

    getSearchKey(): string
    {
        return this.searchKey;
    }
    setSearchKey(searchKey: string)
    {
        this.searchKey = searchKey;
    }

    getCategoryId(): string
    {
        return this.categoryId;
    }
    setCategoryId(categoryId: string)
    {
        this.categoryId = categoryId;
    }

    getToneId(): number
    {
        return this.toneId;
    }
    setToneId(toneId: number)
    {
        this.toneId = toneId;
    }

    getPageNo(): number
    {
        return this.pageNo;
    }
    setPageNo(pageNo: number)
    {
        this.pageNo = pageNo;
    }

    setSearchLanguage(searchLanguage: string)
    {
        this.searchLanguage = searchLanguage;
    }
    getSearchLanguage(): string 
    {
        return this.searchLanguage;
    }   

    getPagePerCount(): number
    {
        return this.pagePerCount;
    }
    setPagePerCount(pagePerCount: number)
    {
        this.pagePerCount = pagePerCount;
    }
     
    getCountList(): CountSearchDetailsDto
    {
        return this.countList;
    }
    setCountList(countList: CountSearchDetailsDto)
    {
        this.countList = countList;
    }

    getSongList(): ToneDto[]
    {
        return this.songList;
    }
    setSongList(songList: ToneDto[])
    {
        this.songList = songList;
    }

    getToneList(): ToneDto[]
    {
        return this.toneList;
    }
    setToneList(toneList: ToneDto[])
    {
        this.toneList = toneList;
    }

    setSortBy(orderBy: string) {
        this.orderBy = orderBy;
    }
    setAlignBy(alignBy: string) {
        this.alignBy =alignBy;
    }
    getSortBy(): string {
        return this.orderBy;
    }
    getAlignBy(): string {
        return this.alignBy;
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/specificsearchtone/specificsearchtonedto.ts